




































































































































































































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AccountModule from '@/store/modules/Account';
import GeneralModule from '@/store/modules/General';
import BalanceModule from '@/store/modules/Balance';
import ProfileModule from '@/store/modules/Profile';
import AuthModule from '@/store/modules/Auth';
import CreateAccountData from '@/data/CreateAccount';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component
export default class AddAgentView extends Mixins(ErrorHandleMixin) {
  AccountInstance = getModule(AccountModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  BalanceInstance = getModule(BalanceModule, this.$store);

  ProfileInstance = getModule(ProfileModule, this.$store);

  mainKey = 0;

  api = 'API';

  ipWhitelist = '';

  UserData: any = { ...CreateAccountData.initialUserData() };

  isCheckedPrefix = false;

  productSelected = 'pg';

  async created() {
    this.initial();
  }

  async initial() {
    this.UserData.role = 'AGENT';
    if (this.AuthInstance.user.role === 'COMPANY') {
      this.UserData.type = 'CREDITLINE';
      this.api = 'B2B';
    }
    const { status, data } = await this.AccountInstance.GenerateUser({
      role: this.UserData.role,
    });
    if (status.code) {
      this.checkError(status);
    } else {
      this.UserData.username = data.username;
    }
  }

  toggleAPI({ target: { innerText } }) {
    this.api = innerText;
    if (this.AuthInstance.user.role === 'COMPANY') {
      this.UserData.type = 'CREDITLINE';
    } else {
      this.UserData.type = 'SEAMLESS';
    }
  }

  toggleBetType({ target: { innerText } }) {
    this.UserData.type = innerText.trim().toUpperCase().replace(' ', '');
  }

  isAbleToSubmit(invalid: boolean): boolean {
    if (!invalid && ['CREDITLINE', 'SEAMLESS', 'TRANSFER'].includes(this.UserData.type)) return false;
    return true;
  }

  async onSubmit() {
    if (this.ipWhitelist) {
      this.UserData.ipWhitelist = this.ipWhitelist.split(',');
    }
    this.GeneralInstance.toggleLoading(true);
    const {
      status: { code, message },
      data,
    } = await this.AccountInstance.CreateAccount(this.UserData);
    if (code === 0) {
      await this.BalanceInstance.Refill({
        userId: data._id,
        type: 'TRANSFER',
        amount: this.UserData.balance,
        username: data.username,
      });
      this.mainKey += 1;
      this.ipWhitelist = '';
    }
    await this.ProfileInstance.GetBalance();
    this.GeneralInstance.toggleLoading(false);
    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: message,
      alertColor: code === 0 ? 'success' : 'danger',
    });
    this.isCheckedPrefix = false;
    this.UserData = { ...CreateAccountData.initialUserData() };
    this.initial();
  }

  async checkPrefix() {
    if (!this.UserData.prefix) {
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: 'Prefix Required',
        alertColor: 'danger',
      });
    } else {
      this.GeneralInstance.toggleLoading(true);
      const { code, message } = await this.AccountInstance.CheckPrefix({
        prefix: this.UserData.prefix,
      });
      this.GeneralInstance.toggleLoading(false);
      this.isCheckedPrefix = code === 0;
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: message,
        alertColor: code === 0 ? 'success' : 'danger',
      });
    }
  }

  @Watch('UserData.prefix')
  changePrefix() {
    this.isCheckedPrefix = false;
  }
}
